import { AfterViewInit, Component, ViewChild, Output, EventEmitter, Input, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { environment } from 'src/environments/environment';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';


@Component({
  selector: 'app-select-service-type',
  templateUrl: './select-service-type.component.html',
  styleUrls: ['./select-service-type.component.scss']
})

export class SelectServiceTypeComponent implements AfterViewInit {
  @Output() serviceTypeDetailsOutputEvent = new EventEmitter();
  @Input() serviceTypeInfo: any;
  @ViewChild('empTbSort') empTbSort = new MatSort();
  @Output() dataInformation = new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  searchterms: any = '';
  departmentDataSource: any;
  caseTypeVal: any = [];
  input: any;
  tcontainer = {
    height: (($(window).height() - $('.layout-navbar').height()) - 350) + 'px'
  };
  gotoNext(data: any, rowInfo?: Object) {
    this.agentscriptservice.addtorecentservices(data.serviceDetails).subscribe((response)=>
    {
      console.log(response)
    })
    console.log(data)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'modifiedfromanonymouscontact', 0)
    console.log(data.serviceDetails)
    // this.
    console.log(data)
    if (rowInfo) {
      let dataVal: any = rowInfo;
      localStorage.setItem("contentNameForListView", JSON.stringify(dataVal));
      localStorage.setItem("ServiceTypeInfo", "");
    }

    // console.log(this.apiservice.gensysdata)
    if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) {
      console.log("hello")
      data['gensysdata'] = this.apiservice.gensysdata;
    }
    this.serviceTypeDetailsOutputEvent.emit(data)
    console.log(data)
    this.apiservice.gensysdata;
    localStorage.setItem("userInfo", '');

  }
  // dataSource:any;
  dataSource1: any;
  dataSource!: MatTableDataSource<any>
  displayedColumns: string[] = ['id', 'myfavourite', 'casetype', 'division', 'resolution', 'actions'];
  searchTerm: string = '';
  objListVal: any = [];
  departmentItems: any = [];
  pageSize: any = 5;
  pageSizeOptions: any = [10, 15, 20, 25];
  // @ViewChild(MatPaginator) paginator!: MatPaginator;
  // @ViewChild(MatSort) sort!: MatSort;

  constructor(private stnadardUiService:StandardUIService,private cdr: ChangeDetectorRef, private agentscriptservice: AgentscriptService_updated, private http: HttpClient, private _liveAnnouncer: LiveAnnouncer, private apiservice: ApiserviceService) {
    // console.log("page");
  }

  selectAllStars: boolean = false;

  // toggleAllStars() {
  //   for (let item of this.caseTypeVal) {
  //     item.myfavourite = this.selectAllStars;
  //   }
  //   console.log("selectAllStarsselectAllStars", this.selectAllStars);
  // }

  // togglefavourites(data: any) {
  //   console.log(data)
  //   data.myfavourite = !data.myfavourite;
  //   // this.selectAllStars = this.caseTypeVal.every(data => data.myfavourite);
  //   // console.log("selectAllStarsselectAllStars",this.selectAllStars);

  // }

  clearsearch() {
    // this.searchterms = ""
    // this.agentscriptservice.updateOrInsertArray(this.tab_title, 'searchterms', '')
    // this.dataSource = this.dataSource1
    // console.log(this.dataSource1)

    // // this.dataSource.filter = '';
    // $('.dataTables_filter input').val("").keyup();
    // //this.dataSource.paginator = this.paginator;
    // // this.newcaseTypeVal=this.dataSource.filteredData


    this.searchterms = ""
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'searchterms', '')
    this.dataSource = this.dataSource1
    
    this.datatableload=false

    // this.agentscriptservice.getMyFavourites().subscribe((data) => {
    //   console.log(data)
    //   this.favouritesarray = data;
    //   if (this.favouritesarray && this.favouritesarray.length > 0) {
    //   this.commonitems = this.caseTypeVal.filter(item1 =>
    //     this.favouritesarray?.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
    //   );
    // }
    // else{
    //   this.commonitems=[]
    // }
    
    // this.agentscriptservice.commonitems=this.commonitems
    //   console.log(this.commonitems)
      
    // })

      console.log(this.caseTypeVal)
    
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'filteredvalue', [])

    console.log(this.newcaseTypeVal)
   
    console.log(this.caseTypeVal)
   
    setTimeout(() => {
      
    this.caseTypeVal=this.newcaseTypeVal
    this.datatablepagination();
    }, 100);
  

  }

  filterboxes: any;
  newcaseTypeVal: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('dataTable') dataTable: ElementRef;

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  tableId: any
  tab_title: any
  favouritesarray: any=[]
  getfavourites() {

    this.agentscriptservice.getMyFavourites().subscribe((data) => {
      console.log(data)
      this.favouritesarray = data;
      if (this.favouritesarray && this.favouritesarray.length > 0) {
      this.commonitems = this.caseTypeVal.filter(item1 =>
        this.favouritesarray?.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
      );
    }
    else{
      this.commonitems=[]
    }
    
    this.agentscriptservice.commonitems=this.commonitems
      console.log(this.commonitems)
      
    })
    // this.http.get(environment.apiURL + 'getStarred').subscribe((data: any) => {
    //   this.favouritesarray = data;
    //   console.log(data)
    //   console.log(this.caseTypeVal)
    //   this.commonitems = this.caseTypeVal.filter(item1 =>
    //     this.favouritesarray.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
    //   );

    //   console.log(this.commonitems)

    // })
  }


  getIdbasedarrayItem(itemarray: any) {

    const item = this.favouritesarray.find(item => item.casetypeid == itemarray.casetypeid && item.departmentid == itemarray.department.id);

    if (item) {
      return item.starredid
    }
    else {
      return 0
    }

  }


  getidbycasetypedepartment(arrayItem: any) {
    // console.log(arrayItem)
    // console.log(this.commonitems)

    // console.log(this.commonitems)
    // console.log((casesubtypeid !== "" && this.favouritesarray[0].hasOwnProperty('casesubtypeid')) ? this.favouritesarray[0].casesubtypeid == casesubtypeid : true)
    // console.log(casetypeid,departmentid,casesubtypeid)
    // console.log(this.favouritesarray)
    // const item =this.favouritesarray.find(item => { return item.casetypeid == casetypeid && item.departmentid == departmentid });
    // console.log(((casesubtypeid !== "" && this.favouritesarray[0].hasOwnProperty('casesubtypeid') && this.favouritesarray[0].casesubtypeid!=null) ? this.favouritesarray[0].casesubtypeid == casesubtypeid : true))

    // this.commonitems.forEach((item:any)=>
    // {
    //   item.
    // })

    // var elementfound=false;
    arrayItem.isfavourite = 'false'
    this.commonitems?.forEach((item: any) => {
      if (item.casetypeid == arrayItem.casetypeid && item.division.id == arrayItem.division.id && (((item.casesubtypeid != null && arrayItem.casesubtypeid != null) ? item.casesubtypeid == arrayItem.casesubtypeid : true))) {
        // elementfound=true
        arrayItem.isfavourite = 'true'
      }
    })

    // if(elementfound)
    //   return true

    // if (this.commonitems?.includes(arrayItem)) {
    //   arrayItem.isfavourite = 'true'
    //   // return true
    // }
    // else {
    //   arrayItem.isfavourite = 'false'
    //   // this.datatablepagination();
    //   // return false;
    // }


  }

  togglefavourite(item: any, index: any, favourite: any) {

    console.log(item, index, favourite)
    var formdata: any
    if (favourite == true) {
      // alert("true")
      delete item.isfavourite;
      // alert('fav')
      item.isfavourite = 'true';
      formdata = {
        "casetype": item.casetypeid,
        "department": item.department.id,
        "casesubtype": item?.casesubtypeid,
        "isfav": favourite
      }
      this.caseTypeVal[index].isfavourite = true
      // console.log(item)
      console.log(this.caseTypeVal[index])

    }
    else {
      // alert("false")
      delete this.caseTypeVal[index].isfavourite;
      console.log(this.caseTypeVal[index])
      item.isfavourite = false;
      item.test = false
      formdata = {
        "casetype": item.casetypeid,
        "department": item.department.id,
        "casesubtype": item?.casesubtypeid,
        "isfav": favourite,
        "id": this.getIdbasedarrayItem(item)
      }
      console.log(item)
      // alert(this.caseTypeVal[index].isfavourite=false)
      this.caseTypeVal[index].isfavourite = false
      console.log(this.caseTypeVal[index])
      if($("[data-filter-id='" + this.tab_title+'-favourites'+"']").hasClass('activetab'))
        {       
           // alert()
        this.caseTypeVal.splice(index, 1)
        // this.datatablepagination()
        // setTimeout(() => {
          
        
        // }, 100);
      }
    }

    console.log(formdata)

    this.http.post(environment.apiURL + 'updateStarred', formdata).subscribe((data: any) => {
      console.log(data)


      // this.caseTypeVal[index]={"casetypeid":item.casetypeid}

      // var casetypevalues=this.caseTypeVal
      //   this.caseTypeVal=[]
      // setTimeout(() => {
      // this.caseTypeVal[index].casetypeid=data.casetypepicklist.id
      // this.caseTypeVal[index].department.id=data.departmentpicklist.id
      // Object.keys(this.caseTypeVal).forEach(key => delete this.caseTypeVal[key]);
      // this.caseTypeVal=[]
      // this.caseTypeVal[index].casesubtypeid
      // this.caseTypeVal=casetypevalues
      // this.datatablepagination()
      // }, 100)
      // this.caseTypeVal[index]=item
      console.log(item)
      // console.log(this.caseTypeVal)
      
      this.getfavourites();
      // 240425-000033-favourites
      if($("[data-filter-id='" + this.tab_title + "-favourites']")?.attr('class')?.includes('activetab'))
        {
          // alert()
          this.datatableload=false
          setTimeout(() => {
          this.datatablepagination()
          }, 1000);
        }
      // this.cdr.detectChanges();
      // this.cdr.detectChanges();
      // this.cdr.markForCheck();
      // this.cdr.detectChanges();
      
    })
  }

  applyfiltersfromservice() {

    if (this.agentscriptservice.fetchData(this.tab_title, 'searchterms') != 0) {

      setTimeout(() => {
        $('.pane:visible .dt-search input').val(this.searchterms).keyup();

      }, 1000);
      this.searchterms = this.agentscriptservice.fetchData(this.tab_title, 'searchterms')
      // $('.pane:visible .dataTables_filter input').val(this.searchterms).trigger('keyup');
    }
    if (this.agentscriptservice.fetchData(this.tab_title, 'filteredvalue') != 0) {
      console.log(this.agentscriptservice.fetchData(this.tab_title, 'filteredvalue'))

      setTimeout(() => {
        // alert(this.agentscriptservice.fetchData(this.tab_title,'filteredvalue')+'-'+this.tab_title)
        // alert($('#filteredtag-' + this.agentscriptservice.fetchData(this.tab_title,'filteredvalue')+'-'+this.tab_title).attr('data-filter-id'))
        // alert($('#filteredtag-' + this.agentscriptservice.fetchData(this.tab_title,'filteredvalue')+'-'+this.tab_title).length )
        $('#filteredtag-' + this.agentscriptservice.fetchData(this.tab_title, 'filteredvalue') + '-' + this.tab_title).trigger('click')

      }, 1000);
    }
    else {
    }
  }

  count: number = 0
  datatableload=false;
  ngOnInit() {


    // this.getfilterbyseason("winter")

    // $("[data-filter-id]").attr('data-filter-close', 'open');

    this.dataInformation.emit();
    var filtereddepartment='false'


    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')

    this.stnadardUiService.castuserDetails.subscribe((data)=>{
      if(data){
        console.log(data);
        // console.log(data.roles[0].authority)
        if(data.roles && data.roles[0]?.authority)
        {
          filtereddepartment=data.roles[0]?.authority.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
        }
      }
    })

    console.log(this.serviceTypeInfo)
    console.log(this.serviceTypeDetailsOutputEvent)
    // console.log(this.apiservice.gensysdata)
    this.tableId = $(".custom-tabs li.active").find("a").attr('data-obj-title') + "-listviewtable"
    // console.log("tableIdtableIdtableIdtableId", this.tableId)
    // console.log(this.serviceTypeInfo.serviceDetails.content)
    // console.log(this.serviceTypeInfo)
    // if(this.serviceTypeInfo?.serviceDetails?.content){
    //   setTimeout(()=>{
    //     $('.dataTables_filter input').val(this.serviceTypeInfo?.serviceDetails?.content).keyup();
    //   },300)

    // }
    // let lookup = {};
    // this.http.get<any>('/assets/json/dataArray.json').subscribe((data) => {
    this.http.get<any>(environment.apiURL + 'getDeptcasedefToAgent').subscribe((data) => {

      this.departmentItems = data;

      if (filtereddepartment!='false' && filtereddepartment.includes('parkingcontrol')) { 
        this.departmentItems = this.departmentItems.filter(item =>
          item.content.replace(/[^a-zA-Z0-9]/g, '').toLowerCase().includes(filtereddepartment)
        );
      }

      console.log(data)
      this.departmentItems?.forEach((obj: { caseType: any[]; }) => {
        obj.caseType.forEach((ele: any) => {
          this.caseTypeVal.push(ele);
        });

      })

      

      // this.caseTypeVal?.forEach(datarray => {
      //   datarray.isfavourite = 'false';
      // });

      // console.log(this.caseTypeVal)
      // this.getfavourites();



      // console.log(this.caseTypeVal)
      this.newcaseTypeVal = this.caseTypeVal
      this.agentscriptservice.Allservicerequests=this.caseTypeVal
      // this.dataSource=new MatTableDataSource(this.caseTypeVal)
      // this.dataSource1=new MatTableDataSource(this.caseTypeVal)

      // this.dataSource.data=this.dataSource.filteredData



      // this.dataSource.sort = this.sort;
      // console.log(this.dataSource.data)
      // console.log("dataaasourcevalues",this.dataSource)
      // this.dataSource = this.caseTypeVal;
      // this.dataSource1 = this.caseTypeVal;

      this.ngAfterViewInit();

      this.applyfiltersfromservice()

      this.getfavourites();

      this.datatablepagination()
      // console.log(this.caseTypeVal)
      // .filter((x:any)=>x.filteringvalues.includes('Recents'))
      // this.newcaseTypeVal=this.caseTypeVal.filter((x:any)=>x?.filteringvalues?.includes('Recents'))
    });



    this.http.get<any>('/assets/json/filter_tags.json').subscribe((data) => {
      this.filterboxes = data[0].filter;
      // console.log(data)
      // console.log(this.filterboxes)
    });

  }

  dataTableInstance: any;

  datatablepagination() {

    $("#" + this.tableId+"_wrapper").remove();
    // this.caseTypeVal=this.caseTypeVal
    // $("#" + this.tableId).DataTable().destroy();

    // this.count=this.count+15
    // alert(this.count)
    // this.tableId=this.count
    // this.count++

    setTimeout(() => {
      ($('.pane:visible #' + this.tableId) as any).dataTable({
        "language": {
          "paginate": {
            "previous": "",
            "next": ""
          },
          "lengthMenu": "Records per page _MENU_",
        },
        pageLength: 10,
        "order": [[2, "asc"]],

        "columnDefs": [
          { "orderable": false, "targets": 0 },
          { "orderable": false, "targets": 1 },
          { 'orderable': false, 'targets': 4 },
          { 'orderable': false, 'targets': 5 }
        ],

        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
        //   fixedColumns: {
        //     start: 1,
        //     end: 1
        // },
        paging: true,        
        fixedHeader: true,
        // scrollX: false,
        scrollY: this.tcontainer.height,
        destroy:true,
        dom: 'frtlip',

        drawCallback: function (settings) {
          const api = this.api();
          const rows = api.rows({ page: 'current' }).nodes();
          let startIndex = api.page() * api.page.len() + 1;

          $(rows).each(function (index) {
            $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
            startIndex++;
          });
        },
      });
    }, 200);

    
    this.datatableload=true
  }
  // datatablepagination() {
  //   // $("#" + this.tableId).DataTable().destroy();

  //   // if (this.dataTableInstance) {
  //   //   this.dataTableInstance.destroy();
  //   // }


  //   setTimeout(() => {
  //     const dataTableOptions = {
  //       "language": {
  //         "paginate": {
  //           "previous": "",
  //           "next": ""
  //         },
  //         "lengthMenu": "Records per page _MENU_",
  //       },
  //       pageLength: 10,
  //       "order": [[2, "asc"]],
  //       "columnDefs": [
  //         { "orderable": false, "targets": 0 },
  //         { "orderable": false, "targets": 1 },
  //         { 'orderable': false, 'targets': 5 }
  //       ],
  //       "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
  //       paging: true,
  //       fixedHeader: true,
  //       scrollY: 340,
  //       dom: 'frtlip',
  //       drawCallback: function (settings) {
  //         const api = this.api();
  //         const rows = api.rows({ page: 'current' }).nodes();
  //         let startIndex = api.page() * api.page.len() + 1;
  
  //         $(rows).each(function (index) {
  //           $('td', this).eq(0).html(startIndex.toString());
  //           startIndex++;
  //         });
  //       },
  //     };
  //     this.dataTableInstance = ($('.scroll#' + this.tableId) as any).DataTable(dataTableOptions);

  //   }, 200);
  // }
    
  // pagination() {
  //   $('body').addClass('pagination');
  // }

  closefilter(data: any) {
    
    this.datatableload=false

    this.agentscriptservice.getMyFavourites().subscribe((data) => {
      console.log(data)
      this.favouritesarray = data;
      if (this.favouritesarray && this.favouritesarray.length > 0) {
      this.commonitems = this.caseTypeVal.filter(item1 =>
        this.favouritesarray?.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
      );
    }
    else{
      this.commonitems=[]
    }
    
    this.agentscriptservice.commonitems=this.commonitems
      console.log(this.commonitems)
      
    })

      console.log(this.caseTypeVal)
    
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'filteredvalue', [])

    console.log(this.newcaseTypeVal)
    console.log(data)

    // $("[data-filter-id='" + this.tab_title+'-'+data + "']").attr('data-filter-close', 'open')

    
    $(".pane:visible [data-filter-id]").removeClass('activetab');
    // $(".pane:visible  [data-filter-id='" + this.tab_title+'-'+data + "']").addClass('activetab');
    
    console.log(this.caseTypeVal)
   
    setTimeout(() => {
      
    this.caseTypeVal=this.newcaseTypeVal
    this.datatablepagination();
    }, 100);
  }

  displayclose(item: any) {
    // console.log(item)
    // console.log($("[data-filter-id='" + this.tab_title+'-'+item + "']").attr('class').includes('activetab'))
    return $("[data-filter-id='" + this.tab_title+'-'+item + "']").attr('class').includes('activetab')
    // return $("[data-filter-id='" + this.tab_title+'-'+item + "']").hasClass('data-filter-close')
    // return $(item.nativeElement).hasClass('activetab');

  }


  getfilterbyseason(filtertype: any) {
    this.agentscriptservice.getfilterbyseason(filtertype).subscribe((data) => {
      console.log(data)

      // console.log(this.commonitems)
    })
  }

  // myfavouritesfilter() {
  //   // alert("in fav")
  //   this.caseTypeVal = this.newcaseTypeVal

  //   console.log(this.favouritesarray)
  //   this.commonitems = this.caseTypeVal.filter(item1 =>
  //     this.favouritesarray.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
  //   );
  //   console.log(this.commonitems)
  //   this.caseTypeVal = this.commonitems
  // }

  commonitems: any

  triggerfavouritesfunction()
  {
    // alert($("[data-filter-id='" + this.tab_title+'-favourites'+"']").hasClass('activetab'))
    if($("[data-filter-id='" + this.tab_title+'-favourites'+"']").hasClass('activetab'))
      {
        // alert()
        // alert($('#filteredtag-favourites-'+this.tab_title).length)
        $('#filteredtag-favourites-'+this.tab_title).trigger('click')
      }
  }

  filter(data: any) {
    this.searchterms=""
    // this.triggerfavouritesfunction()
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'filteredvalue', data)

    if (data.toLowerCase().includes('favourite')) {
      console.log('favvvvv')
      this.caseTypeVal = this.newcaseTypeVal

      this.datatableload=false;
      // this.caseTypeVal = this.agentscriptservice.commonfavcasetype
      // this.caseTypeVal = this.newcaseTypeVal
      // this.datatableload=false
      this.agentscriptservice.getMyFavourites().subscribe((data) => {
        console.log(data)
        this.favouritesarray = data;
        if (this.favouritesarray && this.favouritesarray.length > 0) {
          this.commonitems = this.caseTypeVal.filter(item1 =>
            this.favouritesarray.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
          );          
        this.agentscriptservice.commonitems=this.commonitems
        }
        else{
          this.commonitems=[]
        }
       

        // console.log(this.commonitems)

        this.caseTypeVal = this.commonitems

        // console.log(this.caseTypeVal)

        setTimeout(() => {
          
        this.datatablepagination()
        }, 100);

      })

      // $("[data-filter-id='" + data + "']").attr('data-filter-close', 'close')

      // $("[data-filter-id]").not("[data-filter-id='" + data + "']").attr('data-filter-close', 'open');

    
    }
    else if (data.toLowerCase().includes('recent')) {
      this.caseTypeVal = this.newcaseTypeVal
      this.datatableload=false
      this.agentscriptservice.getRecents().subscribe((data) => {
        
        console.log(data)

        var newdata: any = []
        newdata = data
        var filteringarray;
        filteringarray = this.caseTypeVal.filter(item1 =>
          newdata.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
        );


        console.log(filteringarray)
        this.caseTypeVal = filteringarray
        this.datatablepagination()
      })


      }
    else {

      console.log(this.caseTypeVal)
      this.caseTypeVal = this.newcaseTypeVal
      this.datatableload=false
      this.agentscriptservice.getfilterbyseason(data).subscribe((data) => {
        
        console.log(data)

        var newdata: any = []
        newdata = data
        var filteringarray;
        filteringarray = this.caseTypeVal.filter(item1 =>
          newdata.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
        );


        console.log(filteringarray)
        this.caseTypeVal = filteringarray
        this.datatablepagination()
      })



     

      // this.caseTypeVal = [...this.newcaseTypeVal].filter((x: any) => {
      //   return x.filteringvalues && x.filteringvalues.some((value: string) =>
      //     value.toLowerCase().includes(data.toLowerCase())
      //   );
      // })
    }
    $(".pane:visible [data-filter-id]").removeClass('activetab');
    $(".pane:visible  [data-filter-id='" + this.tab_title+'-'+data + "']").addClass('activetab');
    

    //$("[data-filter-id='" + this.tab_title+'-'+data + "']").add('closefilter')

    //$("[data-filter-id]").not("[data-filter-id='" + this.tab_title+'-'+data + "']").attr('data-filter-close', 'open');
    
  }
  // filter(data: any) {
  //   this.caseTypeVal = this.newcaseTypeVal
  //   this.agentscriptservice.updateOrInsertArray(this.tab_title,'filteredvalue',data)
  //   // caseTypeVal

  //   if (data.toLowerCase().includes('favourite')) {
  //     this.agentscriptservice.getMyFavourites().subscribe((data)=>{
  //       console.log(data)
  //       this.favouritesarray = data;
  //       this.commonitems = this.caseTypeVal.filter(item1 =>
  //             this.favouritesarray.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
  //           );

  //           console.log(this.commonitems)

  //         this.caseTypeVal=this.commonitems

  //         console.log(this.caseTypeVal)
  //         this.datatablepagination()

  //     // this.myfavouritesfilter()
  //     })

  //     // setTimeout(() => {

  //     // }, 10);
  //     // console.log(this.commonitems)

  //     // this.caseTypeVal=this.commonitems

  //     $("[data-filter-id='" + data + "']").attr('data-filter-close', 'close')

  //     $("[data-filter-id]").not("[data-filter-id='" + data + "']").attr('data-filter-close', 'open');

  //     // this.caseTypeVal = this.favouritesarray.filter(person1 =>
  //     //   this.array2.some(person2 =>
  //     //     person1.id === person2.id &&
  //     //     person1.age === person2.age &&
  //     //     person1.city === person2.city
  //     //   )
  //     // );
  //   }
  //   else {

  //     this.agentscriptservice.getfilterbyseason(data).subscribe((data)=>{
  //       console.log(data)

  //           // console.log(this.commonitems)
  //     })


  //     // this.caseTypeVal = this.newcaseTypeVal
  //     // console.log(this.caseTypeVal)
  //     // console.log(this.newcaseTypeVal)
  //     // console.log(data)
  //     // this.searchterms = ''
  //     $("[data-filter-id='" + data + "']").attr('data-filter-close', 'close')


  //     $("[data-filter-id='" + data + "']").add('closefilter')

  //     $("[data-filter-id]").not("[data-filter-id='" + data + "']").attr('data-filter-close', 'open');

  //     // this.caseTypeVal = [...this.newcaseTypeVal].filter((x: any) => x.filteringvalues && x.filteringvalues.includes(data))

  //     this.caseTypeVal = [...this.newcaseTypeVal].filter((x: any) =>
  //   {
  //     return x.filteringvalues && x.filteringvalues.some((value: string) =>
  //     value.toLowerCase().includes(data.toLowerCase())
  //   );
  //   })


  //   }


  //   // this.datatablepagination()

  // }

  onSelect(item: any) {
    this.searchterms = item.content
    $('.dataTables_filter input').val(this.searchterms).keyup();

  }

  ngAfterViewInit() {


  }

  applyFilter(event: Event) {
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'searchterms', this.searchterms.toLowerCase())
    this.searchterms = this.searchterms.toLowerCase(); // Convert to lowercase
    $('.pane:visible .dt-search input').val(this.searchterms).keyup();


  }
  onEnter(event: any) {
    const filterValue = (event.option.value && event.option.value.name || '').toString().toLowerCase();
    this.dataSource.filter = filterValue;
  }

}
